// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610071236/js/" + chunkId + "." + {"44":"c08219f1","225":"06ff7539","481":"98e5b461","486":"07cae682","770":"4cddd856"}[chunkId] + ".0.8012528110329293.chunk.js";
};